import {
	AppBar as AppBarMui,
} from '@mui/material';
import { ChildrenProps, appendClassName } from '@componentLibraryWrapper/common';
import './appbar.scss';

export interface AppBarProps extends ChildrenProps<HTMLElement> {
	position?: 'fixed' | 'absolute' | 'sticky' | 'static' | 'relative';
}

const AppBar = ({
	className,
	position='fixed',
	...rest
 }: AppBarProps) => {
	return (
		<AppBarMui
			{...rest}
			className={appendClassName('sm-appbar', className)}
			position={position}/>
	)
}

export default AppBar;